<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-card-title class="justify-center">EDITAR CATÁLOGO DE PÁGINA</v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12">
                                <p>
                                    <router-link
                                        exact
                                        style="text-decoration: none"
                                        :to="{ name: 'inicioPanel' }"
                                    >
                                        Inicio
                                    </router-link>
                                    /
                                    <router-link
                                        exact
                                        style="text-decoration: none"
                                        :to="{ name: 'pageDataCatalogPanel.index' }"
                                    >
                                        Catálogo de Páginas
                                    </router-link>
                                    /
                                    <a style="text-decoration: none" href="#">Editar</a>
                                </p>
                            </v-col>

                            <v-col cols="12">
                                <v-divider></v-divider>
                            </v-col>
                        </v-row>

                        <FormPageDataCatalog
                            v-model="formData"
                            :processForm="processForm"
                            :alertError="alertError"
                            :listErrors="listErrors"
                            @submit="actualizar"
                        />
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import FormPageDataCatalog from './components/FormPageDataCatalog.vue';

    export default {
        components: {
            FormPageDataCatalog,
        },
        data() {
            return {
                formData: {
                    url_path: '',
                    title: '',
                    seo_title: '',
                    seo_description: '',
                    seo_image: null,
                    seo_image_url: '',
                    banner_title: '',
                    banner_description: '',
                    banner_image_name: '',
                    banner_image_mobil_name: '',
                    banner_image: null,
                    banner_image_mobil: null,
                    banner_image_url: '',
                    banner_image_mobil_url: '',
                    estado: 1,
                },
                processForm: false,
                listErrors: [],
                alertError: false,
            };
        },

        mounted() {
            this.obtenerDatos();
        },

        methods: {
            obtenerDatos() {
                this.processForm = true;
                this.axios
                    .get(`api/panel/page-data-catalog/${this.$route.params.id}`)
                    .then((response) => {
                        const data = response.data;
                        this.formData = {
                            ...this.formData,
                            ...data,
                            seo_image: null,
                            banner_image: null,
                            banner_image_mobil: null,
                        };

                        // console.log(this.formData);
                    })
                    .catch(() => {
                        this.$router.push({ name: 'pageDataCatalogPanel.index' });
                    })
                    .finally(() => {
                        this.processForm = false;
                    });
            },

            actualizar() {
                this.processForm = true;
                this.alertError = false;
                this.listErrors = [];

                const formData = new FormData();
                formData.append('url_path', this.formData.url_path);
                formData.append('title', this.formData.title);
                formData.append('seo_title', this.formData.seo_title);
                formData.append('seo_description', this.formData.seo_description);
                if (this.formData.seo_image) {
                    formData.append('seo_image', this.formData.seo_image);
                }

                formData.append('banner_title', this.formData.banner_title);
                formData.append('banner_description', this.formData.banner_description);
                formData.append('banner_image_name', this.formData.banner_image_name);
                formData.append('banner_image_mobil_name', this.formData.banner_image_mobil_name);

                if (this.formData.banner_image) {
                    formData.append('banner_image', this.formData.banner_image);
                }

                if (this.formData.banner_image_mobil) {
                    formData.append('banner_image_mobil', this.formData.banner_image_mobil);
                }

                formData.append('estado', this.formData.estado);

                formData.append('_method', 'PUT');

                this.axios
                    .post(`api/panel/page-data-catalog/${this.$route.params.id}`, formData)
                    .then(() => {
                        this.$router.push({ name: 'pageDataCatalogPanel.index' });
                    })
                    .catch((error) => {
                        if (error.response.status === 422) {
                            this.listErrors = error.response.data.errors;
                            this.alertError = true;
                        }
                    })
                    .finally(() => {
                        this.processForm = false;
                    });
            },
        },
    };
</script>
